import AuditFindingsMapping from './AuditFindingsMapping';

export default AuditFindingsMapping;
